/* @flow */
import { PRODUCTS_CLEAR } from '../../../ActionsConst';

export const productsClear = () => ({
  type: PRODUCTS_CLEAR,
});
